import ArticleNotifyModal from '@/components/user/ArticleNotifyModal.vue'
import { listArticles } from '@/api/portal/article'
import { countUnread } from '@/utils/articleRead'

export default {
  components: { ArticleNotifyModal },
  data() {
    return {
      notifyVisible: false,
      unreadCount: 0
    }
  },
  mounted() {
    this.refreshUnreadCount()
  },
  methods: {
    refreshUnreadCount() {
      return listArticles()
        .then(res => {
          this.unreadCount = countUnread(res.data || [])
        })
        .catch(() => {
          this.unreadCount = 0
        })
    },
    handleNotify() {
      if (!this.loggedIn) {
        this.goLogin()
        return
      }
      this.notifyVisible = true
    }
  }
}
